function DeliveryIcon() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.5 26.4375H7.5V12.9167C7.5 12.6736 7.59659 12.4404 7.7685 12.2685C7.94041 12.0966 8.17355 12 8.41667 12H28.5833C28.8264 12 29.0596 12.0966 29.2315 12.2685C29.4034 12.4404 29.5 12.6736 29.5 12.9167V26.4375Z"
        fill="#C41719"
      />
      <path
        d="M30.8246 31.5938H29.5M29.5 16.125H35.9167C36.054 16.1251 36.1895 16.156 36.3133 16.2155C36.437 16.275 36.5458 16.3616 36.6316 16.4688L40.2983 21.0521C40.4287 21.2146 40.4998 21.4167 40.5 21.625V30.6954C40.5 30.9385 40.4034 31.1717 40.2315 31.3436C40.0596 31.5155 39.8264 31.6121 39.5833 31.6121H36.6546M33.1667 16.1433V21.4142C33.1667 21.6573 33.2633 21.8904 33.4352 22.0623C33.6071 22.2342 33.8402 22.3308 34.0833 22.3308H40.5M29.5 26.4375H7.5V12.9167C7.5 12.6736 7.59659 12.4404 7.7685 12.2685C7.94041 12.0966 8.17355 12 8.41667 12H28.5833C28.8264 12 29.0596 12.0966 29.2315 12.2685C29.4034 12.4404 29.5 12.6736 29.5 12.9167V26.4375ZM29.5 26.4375V31.5938H14.54C14.3281 30.9897 13.9338 30.4664 13.4116 30.0962C12.8894 29.726 12.2651 29.5272 11.625 29.5272C10.9849 29.5272 10.3606 29.726 9.83838 30.0962C9.31619 30.4664 8.9219 30.9897 8.71001 31.5938H8.41667C8.17355 31.5938 7.94041 31.4972 7.7685 31.3253C7.59659 31.1534 7.5 30.9202 7.5 30.6771V26.4375H29.5ZM14.7188 32.6433C14.7188 33.4638 14.3928 34.2507 13.8126 34.8309C13.2324 35.4111 12.4455 35.7371 11.625 35.7371C10.8045 35.7371 10.0176 35.4111 9.4374 34.8309C8.85721 34.2507 8.53125 33.4638 8.53125 32.6433C8.52902 32.2917 8.58956 31.9425 8.71001 31.6121C8.9219 31.0081 9.31619 30.4848 9.83838 30.1146C10.3606 29.7444 10.9849 29.5455 11.625 29.5455C12.2651 29.5455 12.8894 29.7444 13.4116 30.1146C13.9338 30.4848 14.3281 31.0081 14.54 31.6121C14.6604 31.9425 14.721 32.2917 14.7188 32.6433V32.6433ZM36.8333 32.6433C36.8348 33.4196 36.5448 34.1681 36.0208 34.7408C35.4968 35.3135 34.7768 35.6687 34.0035 35.7359C33.2301 35.8032 32.4597 35.5777 31.8447 35.1041C31.2296 34.6305 30.8148 33.9433 30.6822 33.1784C30.5496 32.4135 30.709 31.6268 31.1287 30.9738C31.5485 30.3208 32.1981 29.8492 32.949 29.6523C33.6999 29.4554 34.4973 29.5475 35.1835 29.9104C35.8697 30.2733 36.3947 30.8806 36.6546 31.6121C36.7723 31.9432 36.8328 32.2919 36.8333 32.6433V32.6433Z"
        stroke="black"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0744 16.3125L10.7178 21.0654H11.8774L13.1974 16.3171L12.0744 16.3125Z"
        fill="white"
      />
      <path
        d="M15.0809 16.321L13.7701 17.7647L13.3118 16.3164L12.8076 18.0122L13.188 19.7081L14.5905 18.0168L15.0809 16.321Z"
        fill="white"
      />
      <path
        d="M14.9711 21.0752L16.3232 16.3223H15.159L13.8115 21.0706L14.9711 21.0752Z"
        fill="white"
      />
      <path
        d="M17.5422 21.0856L18.8576 21.0902L18.271 18.5602L20.1135 16.3373L19.0089 16.3327L18.0235 17.5427L17.7439 16.3281H16.4376L16.9876 18.7069L13.4355 22.9281H14.5585L17.2351 19.7794L17.5422 21.0856Z"
        fill="white"
      />
      <path
        d="M16.2405 21.3496H16.0434L15.7363 22.445H16.4467L16.4834 22.2846L15.9747 22.2754L16.2405 21.3496Z"
        fill="white"
      />
      <path
        d="M17.102 22.1896L17.0104 22.2676H16.7675L16.7125 22.1988L16.8821 21.603L16.9691 21.5342H17.2075L17.2716 21.603L17.102 22.1896ZM17.345 21.3555H16.9325L16.7079 21.5205L16.4971 22.2767L16.6345 22.4555H17.0333L17.2716 22.2676L17.4825 21.5251L17.345 21.3555Z"
        fill="white"
      />
      <path
        d="M17.969 22.043L17.9324 22.208L17.8453 22.2721L17.6161 22.2676L17.5657 22.1896L17.7261 21.6167L17.8224 21.5388H18.0561L18.0974 21.6167L18.0653 21.7451L18.2624 21.7496L18.3174 21.5159L18.189 21.3555H17.7995L17.552 21.5434L17.3457 22.2584L17.497 22.4601H17.8774L18.1065 22.2767L18.1661 22.0476L17.969 22.043Z"
        fill="white"
      />
      <path
        d="M19.2325 21.3601H19.0217L18.5221 21.8001L18.6413 21.3601L18.4396 21.3555L18.1279 22.4601H18.3388L18.4442 22.0796L18.6321 21.9146L18.7375 22.4646H18.93L18.7925 21.7588L19.2325 21.3601Z"
        fill="white"
      />
      <path
        d="M19.3294 21.9598H19.6961L19.7327 21.8131H19.3661L19.4394 21.5427H19.9711L20.0215 21.3594H19.3111L18.9902 22.464H19.7098L19.7602 22.2806H19.2423L19.3294 21.9598Z"
        fill="white"
      />
      <path
        d="M20.1545 21.8301L20.2324 21.5459H20.5211L20.5624 21.5964L20.5257 21.7659L20.4478 21.8393L20.1545 21.8301ZM20.6999 21.8301L20.7824 21.5184L20.6678 21.3672H20.0995L19.7832 22.4718H19.9757L20.1041 22.0134H20.2369L20.3103 22.4718H20.5074L20.4295 22.0134H20.4845L20.6999 21.8301Z"
        fill="white"
      />
    </svg>
  );
}

function GrayDeliveryIcon() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.5 26.4375H7.5V12.9167C7.5 12.6736 7.59659 12.4404 7.7685 12.2685C7.94041 12.0966 8.17355 12 8.41667 12H28.5833C28.8264 12 29.0596 12.0966 29.2315 12.2685C29.4034 12.4404 29.5 12.6736 29.5 12.9167V26.4375Z"
        fill="#7F7F7F"
      />
      <path
        d="M30.8246 31.5938H29.5M29.5 16.125H35.9167C36.054 16.1251 36.1895 16.156 36.3133 16.2155C36.437 16.275 36.5458 16.3616 36.6316 16.4688L40.2983 21.0521C40.4287 21.2146 40.4998 21.4167 40.5 21.625V30.6954C40.5 30.9385 40.4034 31.1717 40.2315 31.3436C40.0596 31.5155 39.8264 31.6121 39.5833 31.6121H36.6546M33.1667 16.1433V21.4142C33.1667 21.6573 33.2633 21.8904 33.4352 22.0623C33.6071 22.2342 33.8402 22.3308 34.0833 22.3308H40.5M29.5 26.4375H7.5V12.9167C7.5 12.6736 7.59659 12.4404 7.7685 12.2685C7.94041 12.0966 8.17355 12 8.41667 12H28.5833C28.8264 12 29.0596 12.0966 29.2315 12.2685C29.4034 12.4404 29.5 12.6736 29.5 12.9167V26.4375ZM29.5 26.4375V31.5938H14.54C14.3281 30.9897 13.9338 30.4664 13.4116 30.0962C12.8894 29.726 12.2651 29.5272 11.625 29.5272C10.9849 29.5272 10.3606 29.726 9.83838 30.0962C9.31619 30.4664 8.9219 30.9897 8.71001 31.5938H8.41667C8.17355 31.5938 7.94041 31.4972 7.7685 31.3253C7.59659 31.1534 7.5 30.9202 7.5 30.6771V26.4375H29.5ZM14.7188 32.6433C14.7188 33.4638 14.3928 34.2507 13.8126 34.8309C13.2324 35.4111 12.4455 35.7371 11.625 35.7371C10.8045 35.7371 10.0176 35.4111 9.4374 34.8309C8.85721 34.2507 8.53125 33.4638 8.53125 32.6433C8.52902 32.2917 8.58956 31.9425 8.71001 31.6121C8.9219 31.0081 9.31619 30.4848 9.83838 30.1146C10.3606 29.7444 10.9849 29.5455 11.625 29.5455C12.2651 29.5455 12.8894 29.7444 13.4116 30.1146C13.9338 30.4848 14.3281 31.0081 14.54 31.6121C14.6604 31.9425 14.721 32.2917 14.7188 32.6433V32.6433ZM36.8333 32.6433C36.8348 33.4196 36.5448 34.1681 36.0208 34.7408C35.4968 35.3135 34.7768 35.6687 34.0035 35.7359C33.2301 35.8032 32.4597 35.5777 31.8447 35.1041C31.2296 34.6305 30.8148 33.9433 30.6822 33.1784C30.5496 32.4135 30.709 31.6268 31.1287 30.9738C31.5485 30.3208 32.1981 29.8492 32.949 29.6523C33.6999 29.4554 34.4973 29.5475 35.1835 29.9104C35.8697 30.2733 36.3947 30.8806 36.6546 31.6121C36.7723 31.9432 36.8328 32.2919 36.8333 32.6433V32.6433Z"
        stroke="black"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export { DeliveryIcon, GrayDeliveryIcon };
